import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { showErrors } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import CarrierDialog from '@/modules/Carrier/scripts/carrier-dialog'
import CarrierDetailDetail from '@/modules/Carrier/views/detail.vue'
import { getCarrier } from '@/modules/Carrier/gql/carrier.gql'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    CarrierDetailDetail
  }
})
export default class CarrierDetail extends mixins(CarrierDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'Carriers',
      to: { name: 'CarrierList' }
    }
  ]

  carrier: Carrier | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'CarrierDetailDetail'
    },
    {
      title: 'Additional',
      route: 'CarrierDetailAdditional'
    }
  ]

  formatPhoneNumber = formatPhoneNumber

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getCarrier()
  }

  async getCarrier () {
    const carrierId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCarrier,
        variables: {
          carrierId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.carrier = result.data.getCarrier as Carrier
      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: this.carrier.name
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }
  async deleteCarrierConfirm () {
    await this.deleteCarrierPost()
    this.$router.replace({
      name: 'CarrierList'
    })
  }
}
